// extracted by mini-css-extract-plugin
export var puzzleTile = "PuzzlePiece-module--puzzleTile--338ba";